module.exports = __webpack_public_path__ + "media/images/flags/cx-b9b5e6cd65826aab60c67ecc613a4612.svg";